import { useEffect, useMemo, useRef } from 'react'
import Link from 'next/link'

import Seo from 'components/seo'
import portfolioComponents, { fallback as fallbackPortfolioComponent } from 'components/portfolio/components/index.tsx'

import { portfolioHomeData, allPortfolio } from 'data/portfolio/index'

export default function portfolioSingle({ portfolioSlug, portfolioData }) {
  const scrollContainer = useRef()
  const iframsContainer = useRef({})

  const [prevProjSlug, nextProjSlug] = useMemo(() => {
    let prevSlug = null
    let nextSlug = null

    const maxId = portfolioHomeData.length - 1
    const id = portfolioHomeData.find((el) => el.slug === portfolioSlug)?.id

    if (id > 0) {
      prevSlug = portfolioHomeData.find((el) => el.id === id - 1)?.slug
    }

    if (id < maxId) {
      nextSlug = portfolioHomeData.find((el) => el.id === id + 1)?.slug
    }

    return [prevSlug, nextSlug]
  }, [portfolioSlug, portfolioHomeData])

  useEffect(() => {
    scrollContainer?.current?.addEventListener('wheel', onScroll)
    // Object.keys(iframsContainer?.current).forEach((thisRefKey) =>
    //   iframsContainer?.current[thisRefKey].contentWindow.addEventListener('wheel', onScroll)
    // )

    return () => {
      scrollContainer?.current?.removeEventListener('wheel', onScroll)
      // Object.keys(iframsContainer?.current).forEach((thisRefKey) =>
      //   iframsContainer?.current[thisRefKey].contentWindow.removeEventListener('wheel', onScroll)
      // )
    }
  }, [])

  const onScroll = (event) => {
    if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) return
    event.preventDefault()
    scrollContainer.current.scrollLeft += event.deltaY
  }

  return (
    <>
      <Seo
        title={portfolioData.seo.title}
        description={portfolioData.seo.description}
        canonical={`/portfolio/${portfolioSlug}`}
      />
      <main ref={scrollContainer} className="relative md:h-screen md:overflow-y-hidden">
        <div className="fixed left-6 top-6 z-40">
          <Link href={`/portfolio#${portfolioSlug}`}>
            <a className="inline-flex items-center rounded-full border border-black bg-backgroundLight p-2 shadow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 34 34"
                className="h-6 w-6 rotate-45"
                stroke="currentColor">
                <path strokeWidth={1.5} d="M32 17H17M17 17H2M17 17V2M17 17V32.5" />
              </svg>
              <span className="sr-only ml-2">Close</span>
            </a>
          </Link>
        </div>

        <div className="h-screen md:flex md:flex-col md:justify-center">
          <div className="space-y-12 overflow-visible pb-12 md:flex md:space-y-0 md:pb-0">
            {portfolioData.blocks.map((thisComponent) => {
              const rawPortfolioComponents = portfolioComponents.find((el) => el.name === thisComponent.componentName)

              const Component = rawPortfolioComponents?.component || fallbackPortfolioComponent

              return (
                <div key={thisComponent.id} className={`${rawPortfolioComponents?.class} flex-none`}>
                  <Component
                    {...thisComponent.props}
                    componentName={thisComponent.componentName}
                    iframsContainerRef={iframsContainer}
                  />
                </div>
              )
            })}
          </div>
        </div>

        {/* MOBILE TOP NEXT PREV */}

        <div className="absolute left-20 top-8 md:hidden">
          <div className="flex justify-between space-x-6">
            {prevProjSlug ? (
              <div className="relative">
                <Link href={`/portfolio/${prevProjSlug}`}>
                  <a className="inline-flex items-center font-light uppercase">
                    <svg className="mr-4 h-5 w-5" viewBox="0 0 22 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM22 3.5L1 3.5V4.5L22 4.5V3.5Z"
                        fill="black"
                      />
                    </svg>
                    précédent
                  </a>
                </Link>
              </div>
            ) : (
              <div></div>
            )}

            {nextProjSlug ? (
              <div className="relative">
                <Link href={`/portfolio/${nextProjSlug}`}>
                  <a className="inline-flex items-center font-light uppercase">
                    suivant
                    <svg
                      className="ml-4 h-5 w-5 rotate-180"
                      viewBox="0 0 22 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM22 3.5L1 3.5V4.5L22 4.5V3.5Z"
                        fill="black"
                      />
                    </svg>
                  </a>
                </Link>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        </div>

        {/* DESKTOP LEFT VERTICAL NEXT RPEV */}
        <div className="absolute top-0 left-0 z-30 hidden h-screen md:block">
          <div className="flex h-full flex-col justify-center pl-8">
            <div className="flex h-full flex-col justify-between md:max-h-[62rem] md:py-24">
              {prevProjSlug ? (
                <div className="relative">
                  <Link href={`/portfolio/${prevProjSlug}`}>
                    <a className="absolute inline-flex w-52 origin-top-right -translate-x-full -rotate-90 items-center font-light uppercase tracking-wider">
                      Projet précédent
                      <svg
                        className="ml-4 h-5 w-5 rotate-180"
                        viewBox="0 0 22 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM22 3.5L1 3.5V4.5L22 4.5V3.5Z"
                          fill="black"
                        />
                      </svg>
                    </a>
                  </Link>
                </div>
              ) : (
                <div></div>
              )}
              {nextProjSlug ? (
                <div className="relative">
                  <Link href={`/portfolio/${nextProjSlug}`}>
                    <a className="absolute inline-flex w-52 origin-top-left -rotate-90 items-center font-light uppercase tracking-wider">
                      <svg className="mr-4 h-5 w-5" viewBox="0 0 22 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM22 3.5L1 3.5V4.5L22 4.5V3.5Z"
                          fill="black"
                        />
                      </svg>
                      Projet suivant
                    </a>
                  </Link>
                </div>
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  )
}

export async function getStaticProps(context) {
  const thisPortfolioPageData = allPortfolio[context.params.portfolioSlug] || {}

  return {
    props: {
      portfolioSlug: context.params.portfolioSlug,
      //template: JSON.parse(JSON.stringify(thisPortfolioPageData)).template,
      portfolioData: thisPortfolioPageData
    }
  }
}

export async function getStaticPaths() {
  return {
    paths: portfolioHomeData.map((thisClient) => ({
      params: { portfolioSlug: thisClient.slug }
    })),
    fallback: false
  }
}
